export default __webpack_public_path__ + "static/floral-fa8a476c3775f4eec4a622b7d1f8c9fc.webp";